// extracted by mini-css-extract-plugin
module.exports = {"legend":"InterestLegend_legend__1Q1qp","checkmark":"InterestLegend_checkmark__Wq7oa"};